import { z } from "zod";

export const DocumentationComment = z.object({
  id: z.string(),

  authorId: z.string(),
  threadId: z.string(),
  roomId: z.string(),

  createdAt: z.coerce.date(),
  editedAt: z.coerce.date().optional(),
  deletedAt: z.coerce.date().optional(),

  body: z.string(),
});

export const DocumentationCommentThread = z.object({
  id: z.string(),

  roomId: z.string(),

  pagePersistentId: z.string(),
  brandId: z.string(),
  designSystemVersionId: z.string(),
  designSystemId: z.string(),

  blockId: z.string().optional(),
  resolved: z.boolean(),

  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type DocumentationComment = z.infer<typeof DocumentationComment>;
export type DocumentationCommentThread = z.infer<typeof DocumentationCommentThread>;
